import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import '../../../styles/VBAMaintenance.css';
import InvoiceReport from './InvoiceReport';
import SpecReport from './SpecReport';
import AggReport from './AggReport';
import ACIPaymentReport from './ACIPaymentReport';

function Reports() {
    const [currentTabIndex, setCurrentTabIndex] = React.useState(0);

    const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
        setCurrentTabIndex(newValue);
    };

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <React.Fragment>
                <Tabs
                    orientation="vertical"
                    variant="scrollable"
                    value={currentTabIndex}
                    onChange={handleTabChange}
                    aria-label="Report tabs"
                    sx={{
                        borderRight: 1,
                        borderColor: 'divider',
                        borderRadius: '10px',
                        maxWidth: '15%',
                        //takes the tabs out of the layout so they don't push the page down
                        position: 'absolute',
                    }}
                    className="tabStyles"
                >
                    <Tab label="Invoice Report" style={{ fontWeight: 'bolder' }} />
                    <Tab label="SPEC REPORT" style={{ fontWeight: 'bolder' }} />
                    <Tab label="AGG REPORT" style={{ fontWeight: 'bolder' }} />
                    <Tab label="ACI Remittance" style={{ fontWeight: 'bolder' }} />
                </Tabs>

                <div style={{ width: '100%' }}>
                    {currentTabIndex === 0 && <InvoiceReport />}
                    {currentTabIndex === 1 && <SpecReport />}
                    {currentTabIndex === 2 && <AggReport />}
                    {currentTabIndex === 3 && <ACIPaymentReport />}
                </div>
            </React.Fragment>
        </div>
    );
}

export default React.memo(Reports);